import type MessageTableVM from 'ab-viewModels/message/messageTable.viewModel';

const CSV_REQUIRED_KEYS = [
	'SentAt',
	'Sender',
	'Type',
	'Destination',
	'Recipient',
	'MessageType',
	'Status',
	'UserGroup',
	'Content',
];

export const toCSVData = (viewModels: MessageTableVM[]): string[][] => {
	const header: string[] = CSV_REQUIRED_KEYS;

	const rows: string[][] = viewModels.reduce((_acc, _item: MessageTableVM) => {
		_acc.push([
			_item.sentAt,
			_item.isAutomatic
				? 'AUTOMATIC'
				: _item.senderFullName ?? '-',
			_item.destinationType,
			_item.destination ?? '-',
			_item.recipient ?? '-',
			_item.messageType,
			_item.currentStatus.status,
			_item.userGroupName ?? '-',
			_item.content,
		]);
		return _acc;
	}, [] as string[][]);

	return [header, ...rows];
};
